import { useEffect } from 'react';
import { FlexCodeImportType } from 'API';
import { useAppDispatch, useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { getMostRecentFlexCodeImportFile, selectFlexCodingSlice } from 'app/pages/store/flexCodingSlice';
import { useAccountType } from 'app/hooks/useAccountType';

// ---------------------------------------------------------------------------
// Flex structured-mode dependent clearing
// ---------------------------------------------------------------------------
// IMPORTANT: these lists define which fields get cleared when a parent field
// changes/clears in Flex structured mode. They are mirrored in mobile at
// src/app/pages/mobile/pages/mobile-transactions/MobileEditTransactionSheet.tsx
// (handleClearOption + handleSelectOption). If you change either list here,
// update the mobile handlers too — otherwise mobile and desktop will drift.

export const GL_CODE_DEPENDENTS = ['flexCode', 'flexCostCode', 'flexCostType', 'flexVendor'] as const;
export const PROJECT_DEPENDENTS = ['flexCostCode', 'flexCostType', 'flexVendor'] as const;

export const GL_CODE_CLEAR_CHANGES = {
  flexCode: null,
  flexCodeId: null,
  flexCostCode: null,
  flexCostCodeId: null,
  flexCostType: null,
  flexCostTypeId: null,
  flexVendor: null,
  flexVendorId: null,
} as const;

export const PROJECT_CLEAR_CHANGES = {
  flexCostCode: null,
  flexCostCodeId: null,
  flexCostType: null,
  flexCostTypeId: null,
  flexVendor: null,
  flexVendorId: null,
} as const;

export const useFlexStructuredMode = () => {
  const dispatch = useAppDispatch();
  const { selectedPaidolId } = useAppSelector(selectUserCompanies);
  const { flexCodeImportFile } = useAppSelector(selectFlexCodingSlice);
  const { isFlexCodingEnabled } = useAccountType();

  const isStructuredMode = flexCodeImportFile?.type === FlexCodeImportType.OPTIMIZED;

  useEffect(() => {
    if (isFlexCodingEnabled && selectedPaidolId && !flexCodeImportFile) {
      dispatch(getMostRecentFlexCodeImportFile(selectedPaidolId));
    }
  }, [isFlexCodingEnabled, selectedPaidolId, flexCodeImportFile, dispatch]);

  return { isStructuredMode, isFlexCodingEnabled };
};
